import splitBillingService from '@/services/splitBillingService';
angular.module('leanlaw').directive('llMatterSummary', [function () {
  return {
    restrict: 'E',
    template: require("./views/matterSummary.html"),
    scope: {
      matter: "=",
      initials: "=?",
      module: "="
    },
    controller: ['$scope', '$state', '$q', 'alerts', function ($scope, $state, $q, alerts) {
      $scope.client = function (matter) {
        $state.go(`${$scope.module.root}.client.view.overview`, {
          id: matter.client.id
        });
      };
      $scope.goToPrimaryMatter = function (matter) {
        if (!matter || !matter.isSecondarySplitMatter) {
          return;
        }

        // First try to use cached primary matter data if available
        if (matter.primaryMatterId && matter.primaryMatterClientId) {
          $state.go('matters-next.client.matter', {
            id: matter.primaryMatterClientId,
            matterId: matter.primaryMatterId
          });
          return;
        }

        // If no cached data, fetch primary matter details
        $q.when(splitBillingService.getPrimaryMatter(matter.id)).then(function (primary) {
          if (primary && primary.client && (primary.matterId || primary.id)) {
            const primaryMatterId = primary.matterId || primary.id;
            const primaryClientId = primary.client.clientId || primary.client.id;
            $state.go('matters-next.client.matter', {
              id: primaryClientId,
              matterId: primaryMatterId
            });
          } else {
            console.warn('Primary matter data incomplete:', primary);
          }
        }).catch(function (error) {
          console.error('Failed to navigate to primary matter:', error);
          alerts.error('Unable to navigate to the primary matter. Please try again or contact support if the issue persists.');
        });
      };
    }]
  };
}]);